
import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import axios from "axios";
import _ from "lodash";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import {
  onFetchOdo,
  canShowRangeSwitch,
  flipRange,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
// import mixpanel from "mixpanel-browser";

let refreshTableReq;
let addressDataFrom = [];
let addressDataTo = [];
let currentData = null; // Stores the raw API response
let currentFilteredData = null; // Stores filtered results
let currentGpsData = null;
let currentDataKey = null;


const refreshTable = (schema, filterParams, store) => {
  if (!filterParams.vehicle?.length) {
    // console.log("Please select at least one vehicle");
    return;
  }

  clearTimeout(refreshTableReq);
  refreshTableReq = setTimeout(() => {
    if (!currentData) {
      return;
    }

    const limit = parseInt(filterParams.limit || 80, 10);
    const duralimit = parseInt(filterParams.duralimit || 20, 10);
    
    currentFilteredData = getOverspeedEntries(
      limit,
      currentData,
      currentDataKey,
      currentGpsData
    );
    
    updateTableData(currentFilteredData, duralimit, schema);
  }, 500);
};

const getOverspeedEntries = (limit, speedData, dataKey, gpsData) => {
  if (!speedData || !speedData.length || !gpsData || !gpsData.length) {
    return [];
  }


  const entries = [];
  let currentEntry = null;

  for (let i = 0; i < speedData.length; i++) {
    const item = speedData[i];
    const speed = parseInt(item[dataKey]);
    
    // Start new overspeed event
    if (speed >= limit && !currentEntry) {
      const gpsPoint = findClosestGpsPoint(item.time, gpsData);
      if (gpsPoint) {
        currentEntry = {
          starttime: item.time,
          startspeed: speed,
          startloc: [gpsPoint.latitude, gpsPoint.longitude],
          maxspeed: speed
        };
      }
    } 
    // End current overspeed event
    else if (speed < limit && currentEntry) {
      const gpsPoint = findClosestGpsPoint(item.time, gpsData);
      if (gpsPoint) {
        currentEntry.endspeed = speedData[i-1][dataKey];
        currentEntry.maxspeed = Math.max(currentEntry.maxspeed, currentEntry.endspeed);
        currentEntry.endloc = [gpsPoint.latitude, gpsPoint.longitude];
        currentEntry.endtime = item.time;
        
        // Only add if duration is positive
        if (currentEntry.endtime > currentEntry.starttime) {
          entries.push(currentEntry);
        }
      }
      currentEntry = null;
    }
    // Update maxspeed during overspeed event
    else if (currentEntry) {
      currentEntry.maxspeed = Math.max(currentEntry.maxspeed, speed);
    }
  }

  // Handle last open entry
  if (currentEntry) {
    const lastGpsPoint = gpsData[gpsData.length - 1];
    currentEntry.endspeed = speedData[speedData.length - 1][dataKey];
    currentEntry.endloc = [lastGpsPoint.latitude, lastGpsPoint.longitude];
    currentEntry.endtime = speedData[speedData.length - 1].time;
    entries.push(currentEntry);
  }

  return entries;
};

// Helper function to find closest GPS point by timestamp
const findClosestGpsPoint = (timestamp, gpsData) => {
  if (!gpsData || !gpsData.length) return null;
  
  const index = _.sortedIndexBy(gpsData, { time: timestamp }, (o) => o.time);
  return gpsData[Math.min(index, gpsData.length - 1)];
};

const updateTableData = (filteredData, duralimit, schema) => {
  const tableData = filteredData
    .filter(entry => {
      const duration = (entry.endtime - entry.starttime) / 1000;
      return (
        entry.startspeed < 500 &&
        entry.endspeed < 500 &&
        duration > duralimit
      );
    })
    .map(entry => {
      const duration = (entry.endtime - entry.starttime) / 1000;
      return {
        ...entry,
        duration,
        startloc: entry.startloc.join(","),
        endloc: entry.endloc.join(",")
      };
    });
  
  if (schema.content[0]?.ref?.setData) {
    schema.content[0].ref.setData(tableData);
  } 
};

const processData = (apiResponse, vehicleMap, filterParams, schema) => {
  currentGpsData = apiResponse[0] || [];
  currentData = (apiResponse[1] && apiResponse[1].length) 
    ? apiResponse[1] 
    : apiResponse[0];
  currentDataKey = apiResponse[1]?.length ? "value" : "speed";

  // Initial filter with current parameters
  refreshTable(schema, filterParams, vehicleMap);
};

// ------------------------
const getHistory = (schema, data, store) => {
  // mixpanel.track("User Looks For Alarm Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  addressDataFrom = [];
  addressDataFrom = [];
  let finalData = null;
  let saveState = null;
  let tableStateData = null;
  if(!data.vehicle.length ){
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
      },
    });
    return;
  }
  let starttime = data.starttime.unix() * 1000
  let endtime = data.endtime.unix() * 1000
  if(starttime > endtime){
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
      },
    });
    return;
  }
  if(endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 35 days",
        content: "You can't select date range of more than 35 days",
        createAt: Date.now(),
        autoClose: 8000,
      },
    });
    return;
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, store.vehicleMap, data, schema);
      if (tableStateData && tableStateData[0]) {
        tableStateData[0].body = finalData;
        tableStateData[0].busy = false;
        saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
      }
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    // let selectedVehicleId=data.vehicle.map((vid)=>vid.data.vehicleid)
    //  data.vehicle[0].data.vehicleid
    let body = {
      vehicleid: data.vehicle[0].data.vehicleid,
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };
    if(window.showNoGpsFixData === true){
      body.fixqfilter = false
    }
    axios
      .all([ReportAPIs.getRTGPS(body), ReportAPIs.getSpeedInfo(body)])
      .then(handleSuccess, (r) => {
        axios.all([ReportAPIs.getRTGPS(body)]).then(
          handleSuccess, (r) => {
            handleSuccess([[],[]])
          }
        )
      });
  } else {
    window.graphDataErr = "";
    console.log("inside else")
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";
    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    // window.dispatchStoreEvent({
    //   type: actions.GRAPHSET_STATE_CHANGED,
    //   data: 0,
    // });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;   
  }
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[5].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const download = (schema, data, store) => {
  let strictColumns =
    store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
      .length > 0;

  // Get the current filter parameters
  const limit = parseInt(data.limit || 80, 10);
  const duralimit = parseInt(data.duralimit || 20, 10);

  if (currentFilteredData) {
    // Apply the same filtering as the table
    let processedData = currentFilteredData
      .filter(entry => {
        const duration = (entry.endtime - entry.starttime) / 1000;
        return (
          entry.startspeed < 500 &&
          entry.endspeed < 500 &&
          duration > duralimit  // Apply duration filter here
        );
      })
      .map((r) => {
        r = Object.assign({}, r);
        r.starttime = moment(r.starttime).format(dateFormat);
        r.endtime = moment(r.endtime).format(dateFormat);
        if (strictColumns) {
          r.startloc = stripLoc(r.startloc);
          r.endloc = stripLoc(r.endloc);
        }
        return r;
      });

    // Rest of your download code...
    if (strictColumns) {
      processedData = processedData.map((r) => {
        let headings = schema.content[0].head
          .filter((c) => (c.isShowable ? c.isShowable(data.vehicle) : true))
          .map((c) => c.key);
        return _.pick(r, headings);
      });
    }

    let heads = schema.content[0].head;
    let removeHeads = ["endtime__processed__","starttime__processed__","uid"];
    heads = heads.filter((head) => !removeHeads.includes(head.key));

    let newData = processedData.map(item => {
      let tempdata = {};
      heads.forEach(head => {
        if(head.key in item) {
          tempdata[head.name] = item[head.key];
        }
      });
      return tempdata;
    });

    JSONToCSVConvertor(newData, "OverspeedingReport", false);
  } 
};

const schema = {
  key: "overpseeding_report",
  name: "Overspeeding",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      singleSelect: true,
      onItemChange: changeVehicle.bind(this),
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "limit",
      type: schemaTypes.INPUT_NUMBER,
      placeholder: "Speed Limit (Default 80kmph)",
      onChange: refreshTable,
    },
    {
      key: "duralimit",
      type: schemaTypes.INPUT_NUMBER,
      placeholder: "Duration(Default 20sec)",
      onChange: refreshTable,
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Overspeeding Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
        },
        { key: "startspeed", name: "Start Speed (Kmph)" },
        { key: "endtime", name: "End Time", type: "DATE", format: dateFormat },
        { key: "endspeed", name: "End Speed (Kmph)" },
        { key: "maxspeed", name: "Max Speed (Kmph)" },
        { key: "duration", name: "Duration (Sec)" },
        { key: "startloc", name: "Start Location", width: 2.3, onClick: (d, item) => {
          let slatlng = item.startloc.split(",")
          window.showInGoogleMaps(slatlng[0],slatlng[1]);
        }, },
        { key: "endloc", name: "End Location", width: 2.3,  onClick: (d, item) => {
          let elatlng = item.endloc.split(",")
          window.showInGoogleMaps(elatlng[0],elatlng[1]);
        },},
      ],
    },
  ],
};
export default schema;